module.exports = __webpack_public_path__ + "media/images/l-icon-cc208d0f7de04594c25b8ad4c84ff32e.svg";